module.exports = __webpack_public_path__ + "img/grower-front.c0632b6b.png";